module.exports = __webpack_public_path__ + "static/media/threeDots.032e5b10.svg";